// Web: Metro picks this file over Firebase.ts, see FirebaseWeb.ts.
export * from './FirebaseWeb';
